import React, { useContext, useEffect, useState } from "react";
import { Tag, Button, message } from "antd";
import { FormOutlined, CloseOutlined, CheckCircleOutlined, SaveOutlined } from "@ant-design/icons";
import { EstadoVistaColaborador } from "enum/EstadoVistaColaborador";
import { useAtom } from "jotai";
import {
	erroresFormularioAtom,
	formularioSeleccionadoAtom,
	visibleVisorFormularioAtom,
} from "pages/mis-documentos/componentes/MisDocumentosWeb/MisDocumentosWebStorage";
import { useFormContext } from "react-hook-form";
import { MisDocumentosContext } from "context/MisDocumentos/MisDocumentosContext";
import { PortalColaboradorService } from "services/PortalColaboradorService";

const Header = ({ loadingPdf }) => {
	const { mostrarModalFirmarFormulario } = useContext(MisDocumentosContext);
	const [formularioSeleccionado] = useAtom(formularioSeleccionadoAtom);
	const [, setVisibleVisorFormulario] = useAtom(visibleVisorFormularioAtom);
	const [, setErroresFormulario] = useAtom(erroresFormularioAtom);
	const { handleSubmit, getValues } = useFormContext();
	const [guardandoAvance, setGuardandoAvance] = useState(false);

	const onClickBtnCerrar = () => {
		setVisibleVisorFormulario(false);
	};

	const onSubmit = (datosFormulario) => {
		mostrarModalFirmarFormulario(datosFormulario);
	};

	const onError = (errores) => {
		setErroresFormulario({ ...errores });
	};

	const onClickBtnFirmar = async () => {
		handleSubmit(onSubmit, onError)();
	};

	const onClickBtnGuardarAvance = async () => {
		// A propósito no se usa handleSubmit: guardar avance no debe exigir que los campos
		// obligatorios ya estén completos, solo persiste lo que se lleva llenado hasta ahora.
		try {
			setGuardandoAvance(true);
			await PortalColaboradorService.guardarAvanceFormulario(formularioSeleccionado.id, getValues());
			message.success("Avance guardado. Puedes continuar más tarde.");
		} catch (error) {
			console.error(error);
			message.error("No se pudo guardar el avance. Intenta nuevamente.");
		} finally {
			setGuardandoAvance(false);
		}
	};

	return (
		<div className="visor-pdf-header" style={{ borderBottom: "0px" }}>
			<div className="informacion">
				<FormOutlined className="icono" />
				<div className="texto">
					<span>
						<span className="periodo">{formularioSeleccionado?.periodo}</span>
						{" - "}
						<span className="documento">{formularioSeleccionado?.nombreDocumento}</span>
					</span>
					<span className="estado">
						<EstadoDocumento estado={formularioSeleccionado?.estadoVistaColaborador} />
					</span>
				</div>
			</div>

			<div className="acciones">
				{formularioSeleccionado?.permiteGuardarAvance &&
					formularioSeleccionado?.estadoVistaColaborador !== EstadoVistaColaborador.FIRMADO && (
						<>
							<Button
								onClick={onClickBtnGuardarAvance}
								loading={guardandoAvance}
								disabled={loadingPdf}
								icon={<SaveOutlined />}
							>
								Guardar avance
							</Button>
							<div className="visor-pdf-header-separador" />
						</>
					)}
				<Button type="primary" onClick={onClickBtnFirmar} loading={loadingPdf} disabled={loadingPdf}>
					{formularioSeleccionado.requiereFirmaColaborador ? "Firmar Documento" : "Confirmar Visualización"}
				</Button>
				<div className="visor-pdf-header-separador" />
				<Button type="text" className="cerrar" onClick={onClickBtnCerrar}>
					<CloseOutlined style={{ fontSize: "16px" }} />
				</Button>
			</div>
		</div>
	);
};

const EstadoDocumento = ({ estado }) => {
	if (estado === EstadoVistaColaborador.PENDIENTE) {
		return <Tag color="volcano">{estado}</Tag>;
	}
	return (
		<Tag color="green" icon={<CheckCircleOutlined />}>
			{estado}
		</Tag>
	);
};

export default Header;
